__turbopack_context__.v({
  "emptyState": "GithubRepos-module-scss-module__PFcnHG__emptyState",
  "githubContainer": "GithubRepos-module-scss-module__PFcnHG__githubContainer",
  "githubSection": "GithubRepos-module-scss-module__PFcnHG__githubSection",
  "header": "GithubRepos-module-scss-module__PFcnHG__header",
  "seeAll": "GithubRepos-module-scss-module__PFcnHG__seeAll",
});
